import {alias, createModelSchema, reference} from "serializr";
import {Schema} from "@/common/Schema";

import {TriggerBase} from "./core/TriggerBase";
import {TriggerKind} from "./core/TriggerKind";
import {TriggerScope} from "./core/TriggerScope";
import {ShipKind} from "../trader/ShipKind";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";


export class TriggerTrader extends TriggerBase {

    constructor() {
        super(TriggerKind.TRADER);

        this._trader = ShipKind.NONE;
        this._config = null;
    }

    get trader() {
        return this._trader;
    }

    set trader(value) {
        this._trader = value;
    }

    get config() {
        return this._config;
    }

    set config(value) {
        this._config = value;
    }

    valid() {

        if (!super.valid()) {
            return false;
        }

        if (!ShipKind.is(this.trader) || ShipKind.NONE.equal(this.trader)) {
            return false;
        }

        if (this.config && !RedactorUtils.getTraderConfig(this.config)) {
            return false;
        }

        return true;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new TriggerTrader());
        } else if (target instanceof TriggerTrader) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

export class TriggerTraderScope extends TriggerScope {
    static _values = [
        new TriggerTraderScope(1, "AVAILABLE"),
        new TriggerTraderScope(2, "COMPLETE"),
        new TriggerTraderScope(3, "EXPIRED"),
        new TriggerTraderScope(4, "CLOSED"),

        new TriggerTraderScope( 5, "ORDERS_ACTIVE"),
        new TriggerTraderScope( 6, "ORDERS_PASSED"),
        new TriggerTraderScope( 7, "ORDERS_REWARDED"),

        new TriggerTraderScope( 8, "OFFERS_ACTIVE"),
        new TriggerTraderScope( 9, "OFFERS_PASSED"),
        new TriggerTraderScope(10, "OFFERS_REWARDED"),

        new TriggerTraderScope(11, "ORDERS_PASSED_COUNT"),
        new TriggerTraderScope(12, "OFFERS_PASSED_COUNT")
    ];

    static getValues() {
        return this._values;
    }

    static getValue(id) {
        let value = this._values.find(v => v.id === id) || null;
        console.assert(value, "unknown id: " + id);
        return value;
    }

    static schema() {
        return reference("id", (id, cb) => {
            return cb(null, TriggerTraderScope.getValue(id));
        });
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new TriggerTraderScope());
        } else if (target instanceof TriggerTraderScope) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(TriggerTrader, {
    _scope: alias("scope", TriggerTraderScope.schema()),
    _trader: alias("trader", ShipKind.schema()),
    _config: alias("config_uid", Schema.primitive())
});
